import api from './api';

export const leadFlowService = {
  // Get users that the current user can control lead flow for
  getControllableUsers: async () => {
    const response = await api.get('/auth/lead-flow/controllable-users/');
    return response.data;
  },

  // Control lead flow for a single user
  controlLeadFlow: async (userId, action, reason = '') => {
    const payload = {
      user_id: userId,
      action: action, // "pause" or "resume"
    };
    
    if (reason) {
      payload.reason = reason;
    }

    const response = await api.post('/auth/lead-flow/control/', payload);
    return response.data;
  },

  // Pause lead flow for a user
  pauseLeadFlow: async (userId, reason) => {
    return leadFlowService.controlLeadFlow(userId, 'pause', reason);
  },

  // Resume lead flow for a user
  resumeLeadFlow: async (userId) => {
    return leadFlowService.controlLeadFlow(userId, 'resume');
  },

  // Get lead flow dashboard data
  getLeadFlowDashboard: async () => {
    const response = await api.get('/auth/lead-flow/dashboard/');
    return response.data;
  },

  // Bulk control lead flow for multiple users
  bulkControlLeadFlow: async (userIds, action, reason = '') => {
    const payload = {
      user_ids: userIds,
      action: action, // "pause" or "resume"
    };
    
    if (reason) {
      payload.reason = reason;
    }

    const response = await api.post('/auth/lead-flow/bulk-control/', payload);
    return response.data;
  },

  // Bulk pause lead flow
  bulkPauseLeadFlow: async (userIds, reason) => {
    return leadFlowService.bulkControlLeadFlow(userIds, 'pause', reason);
  },

  // Bulk resume lead flow
  bulkResumeLeadFlow: async (userIds) => {
    return leadFlowService.bulkControlLeadFlow(userIds, 'resume');
  },
};

// Lead flow status constants
export const LEAD_FLOW_STATUS = {
  ACTIVE: 'active',
  PAUSED: 'paused',
};

export const LEAD_FLOW_ACTIONS = {
  PAUSE: 'pause',
  RESUME: 'resume',
};